export default __webpack_public_path__ + "static/media/CBS_sports_splash_logo.fcda3e78.svg";